import { render, staticRenderFns } from "./YandexFlatUpdateDialog.vue?vue&type=template&id=54a4c9ba&"
import script from "./YandexFlatUpdateDialog.vue?vue&type=script&lang=js&"
export * from "./YandexFlatUpdateDialog.vue?vue&type=script&lang=js&"
import style0 from "./YandexFlatUpdateDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports